import React, { useState, useEffect } from "react";
import { userEndpoint, Base_URL } from "actions/API_endpoint";
import Swal from "sweetalert2";

export default function ManageHeadDesk() {
    const [formData, setFormData] = useState({
        title: "Head's Desk",
        name: "",
        designation: "",
        email: "",
        phone: "",
        message: "",
    });
    const [imageFile, setImageFile] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchHeadDeskData();
    }, []);

    const fetchHeadDeskData = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${Base_URL}${userEndpoint.getHeadDesk}`);
            const data = await response.json();
            if (data.success && data.data) {
                setFormData({
                    title: data.data.title || "Head's Desk",
                    name: data.data.name || "",
                    designation: data.data.designation || "",
                    email: data.data.email || "",
                    phone: data.data.phone || "",
                    message: data.data.message || "",
                });
                if (data.data.image_url) {
                    setPreviewImage(`${process.env.REACT_APP_API_URL || Base_URL}/uploads/${data.data.image_url}`);
                }
            }
        } catch (error) {
            console.error("Error fetching head desk:", error);
            Swal.fire("Error", "Failed to fetch head desk details", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            setPreviewImage(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const token = localStorage.getItem("token"); // Optional based on how the backend validation is handled

        const submitData = new FormData();
        Object.keys(formData).forEach(key => submitData.append(key, formData[key]));
        if (imageFile) {
            submitData.append("image", imageFile);
        }

        try {
            const response = await fetch(`${Base_URL}${userEndpoint.updateHeadDesk}`, {
                method: "POST",
                headers: {
                    ...(token && { Authorization: `Bearer ${token}` }),
                },
                body: submitData,
            });

            const data = await response.json();

            if (data.success) {
                Swal.fire("Success", "Head's Desk updated successfully!", "success");
            } else {
                Swal.fire("Error", data.error || "Something went wrong", "error");
            }
        } catch (error) {
            console.error("Submit error:", error);
            Swal.fire("Error", "Failed to save head desk configuration", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-wrap mt-4 justify-center">
            <div className="relative z-10 w-full lg:w-8/12 px-4 shadow-lg rounded bg-dark-secondary text-white py-6 mb-12">
                <div className="rounded-t bg-dark-tertiary mb-6 px-6 py-4">
                    <div className="flex justify-between items-center">
                        <h6 className="text-white text-xl font-semibold">
                            Manage Head's Desk
                        </h6>
                    </div>
                </div>

                {loading && !formData.name ? (
                    <div className="flex justify-center items-center h-64">
                        <div className="w-12 h-12 border-4 border-accent-primary border-t-transparent rounded-full animate-spin"></div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="px-4">
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-6/12 px-4">
                                <div className="relative w-full mb-3">
                                    <label className="block uppercase text-gray-300 text-xs font-bold mb-2">
                                        Head's Desk Section Title *
                                    </label>
                                    <input
                                        type="text"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        required
                                        className="border-0 px-3 py-3 placeholder-gray-500 text-white bg-dark-primary rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        placeholder="E.g., Head's Desk"
                                    />
                                </div>
                            </div>

                            <div className="w-full lg:w-6/12 px-4">
                                <div className="relative w-full mb-3">
                                    <label className="block uppercase text-gray-300 text-xs font-bold mb-2">
                                        Name *
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        className="border-0 px-3 py-3 placeholder-gray-500 text-white bg-dark-primary rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        placeholder="Enter Head's Name"
                                    />
                                </div>
                            </div>

                            <div className="w-full lg:w-6/12 px-4 mt-3">
                                <div className="relative w-full mb-3">
                                    <label className="block uppercase text-gray-300 text-xs font-bold mb-2">
                                        Designation *
                                    </label>
                                    <input
                                        type="text"
                                        name="designation"
                                        value={formData.designation}
                                        onChange={handleChange}
                                        required
                                        className="border-0 px-3 py-3 placeholder-gray-500 text-white bg-dark-primary rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        placeholder="E.g., Project Director"
                                    />
                                </div>
                            </div>

                            <div className="w-full lg:w-6/12 px-4 mt-3">
                                <div className="relative w-full mb-3">
                                    <label className="block uppercase text-gray-300 text-xs font-bold mb-2">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="border-0 px-3 py-3 placeholder-gray-500 text-white bg-dark-primary rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        placeholder="Optional"
                                    />
                                </div>
                            </div>

                            <div className="w-full lg:w-6/12 px-4 mt-3">
                                <div className="relative w-full mb-3">
                                    <label className="block uppercase text-gray-300 text-xs font-bold mb-2">
                                        Phone No.
                                    </label>
                                    <input
                                        type="text"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className="border-0 px-3 py-3 placeholder-gray-500 text-white bg-dark-primary rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        placeholder="Optional"
                                    />
                                </div>
                            </div>

                            <div className="w-full px-4 mt-4">
                                <div className="relative w-full mb-3">
                                    <label className="block uppercase text-gray-300 text-xs font-bold mb-2">
                                        Message Content *
                                    </label>
                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        className="border-0 px-3 py-3 placeholder-gray-500 text-white bg-dark-primary rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        placeholder="Welcome text..."
                                        rows="6"
                                    />
                                </div>
                            </div>

                            <div className="w-full px-4 mt-6">
                                <div className="relative w-full mb-3">
                                    <label className="block uppercase text-gray-300 text-xs font-bold mb-2">
                                        Head Image Image
                                    </label>
                                    <div className="flex items-center space-x-6">
                                        <div className="shrink-0">
                                            {previewImage ? (
                                                <img
                                                    src={previewImage}
                                                    alt="Preview"
                                                    className="h-14 w-14 object-cover rounded-full border-2 border-dark-tertiary"
                                                />
                                            ) : (
                                                <div className="h-14 w-14 bg-dark-primary rounded-full flex items-center justify-center border-2 border-dark-tertiary border-dashed">
                                                    <span className="text-gray-500 text-xs">No image</span>
                                                </div>
                                            )}
                                        </div>
                                        <label className="block">
                                            <span className="sr-only">Choose file</span>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                                className="block w-full text-sm text-gray-400
                          file:mr-4 file:py-2 file:px-4
                          file:rounded-full file:border-0
                          file:text-sm file:font-semibold
                          file:bg-accent-primary file:text-white
                          hover:file:bg-accent-hover cursor-pointer"
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="w-full px-4 mt-8">
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="bg-accent-primary text-white active:bg-accent-hover font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150 disabled:opacity-50"
                                >
                                    {loading ? (
                                        <span><i className="fas fa-spinner fa-spin mr-2"></i> Saving...</span>
                                    ) : (
                                        <span>Save Head's Desk</span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
